module.exports = __webpack_public_path__ + "static/media/chemicalsIcon.637eade6.svg";